import React, { Component } from 'react'
import { Grid } from '@material-ui/core'
import { Dashboard } from '../layouts'
import {
    ActionDelete,
    ActionNewButton,
    ActionUpdateButton,
    BaseTable,
    BaseTableActions
} from '../components'
import { pathJoin } from '../utils/helpers'

const columns = [
    {
        name: 'title',
        title: 'Гарчиг'
    },
    {
        name: 'created',
        title: 'Бүртгүүлсэн'
    },
    {
        name: 'updated',
        title: 'Шинэчлэгдсэн'
    },
    {
        getCellValue: ({ id }) => <ActionUpdateButton path={pathJoin('covers', id)} />
    }
]

const dateColumns = [
    'created', 'updated'
]

export default class Covers extends Component {
    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    fetchData = () => {
        return this.table.current.fetchData()
    }

    render() {
        return (
            <Dashboard title="Ковер">
                <BaseTableActions>
                    <Grid item>
                        <ActionNewButton path="/covers/new" />
                    </Grid>
                    <Grid item>
                        <ActionDelete
                            path="/covers/mass/destroy"
                            onDelete={this.fetchData}
                        />
                    </Grid>
                </BaseTableActions>
                <BaseTable
                    path="covers"
                    columns={columns}
                    dateColumns={dateColumns}
                    innerRef={this.table}
                />
            </Dashboard>
        )
    }
}
